/*
 * takes an array of numbers and a number
 *
 * returns the value from the array of numbers which is closest to the
 * passed number prioritizing the lower of two numbers from the array
 * should they both have the same difference from the given number
 *
 * closest(6, [ 2, 5, 8 ]) -> 5
 *
 * closest(3, [ 2, 4 ]) -> 2
 */
module.exports = function closest (given, numbers) {
  return numbers.reduce(
    (a, b) => {
      const deltaA = Math.abs(given - a)
      const deltaB = Math.abs(given - b)
      
      /* prioritize the smaller number if the deltas are the same */
      if (deltaA === deltaB) { return Math.min(a, b) }

      return deltaA < deltaB ? a : b
    }
  )
}
